import React from 'react';

import { Anchor, Button, createStyles, TFNotifier } from '@tf/ui';
import { saveFile } from '@tf/utils';

import type { FileInfo } from '../../../../api/files';
import { downloadFile } from '../../../../api/files';

interface DownloadLinkProps {
	view?: 'button' | 'link';
	name?: string;
	icon?: React.ReactElement;
	file: FileInfo;
}

const useStyles = createStyles(() => ({
	anchor: { fontSize: '.85rem' },
}));

export const DownloadLink: React.FC<DownloadLinkProps> = ({ file, view = 'link', name, icon }) => {
	const { classes } = useStyles();

	const downloadDocument = React.useCallback(async () => {
		try {
			const blob = await downloadFile(file.id);
			saveFile(blob, file.meta['@filename']);
		} catch (e) {
			TFNotifier.error('Document download failed', {
				id: 'DownloadError',
			});
		}
	}, [file]);

	if (view === 'button') {
		return (
			<Button size="xs" variant="light" p="4px 8px" leftSection={icon} onClick={downloadDocument}>
				{name ?? file.meta['@filename']}
			</Button>
		);
	}

	return (
		<>
			<Anchor className={classes.anchor} onClick={downloadDocument}>
				{name ?? file.meta['@filename']}
			</Anchor>
		</>
	);
};
